export const TaxAdviceOptions = {
  // **Order matters!!**
  withholding_adjustment: {
    label: 'Withholding adjustment',
    value: 'Withholding adjustment'
  },
  real_estate_taxes: { label: 'Real estate taxes', value: 'Real estate taxes' },
  inheritance_or_estate_taxes: {
    label: 'Inheritance or estate taxes',
    value: 'Inheritance or estate taxes'
  },
  other: { label: 'Other', value: 'Other' }
} as const;
